import request, { _POST } from "@/services/request";
import {
  DakeEditSpecialEventReq,
  DakeListSpecialEventReq,
  DakeListSpecialEventResp,
  DakeSpecialEventDetail,
  DakeSpecialEventIdReq,
  DakeUpdateShowInHomeReq,
} from "@/data-contracts";

/**
 * 列举活动列表
 * */
const getSpecialEventList = (params?: DakeListSpecialEventReq) => {
  return request<DakeListSpecialEventResp, DakeListSpecialEventReq>(_POST, "/admin/specialEvent/list")(params || {});
};

/**
 * 导出专场商品
 * */
const exportProducts = (params?: { id: string }) => {
  return request<{ url: string }, { id?: string }>(_POST, "/admin/specialEvent/exportProducts")(params || {});
};

/**
 * 删除活动
 * /admin/specialEvent/delete
 * */
const deleteSpecialEvent = (params: DakeSpecialEventIdReq) => {
  return request<null, DakeSpecialEventIdReq>(_POST, "/admin/specialEvent/delete")(params);
};

/**
 * 更新活动是否在首页展示
 * */
const updateSpecialEventShowInHome = (params: DakeUpdateShowInHomeReq) => {
  return request<null, DakeUpdateShowInHomeReq>(_POST, "/admin/specialEvent/updateShowInHome")(params);
};

/**
 *
 * 创建活动
 * /admin/specialEvent/create
 * */
const createSpecialEvent = (params: DakeEditSpecialEventReq) => {
  return request<null, DakeEditSpecialEventReq>(_POST, "/admin/specialEvent/create")(params);
};

/**
 *
 * 更新活动
 * /admin/specialEvent/update
 * */
const updateSpecialEvent = (params: DakeEditSpecialEventReq) => {
  return request<null, DakeEditSpecialEventReq>(_POST, "/admin/specialEvent/update")(params);
};

/**
 * 获取活动详情
 * /admin/specialEvent/get
 * */
const getSpecialEventDetail = (params: DakeSpecialEventIdReq) => {
  return request<DakeSpecialEventDetail, DakeSpecialEventIdReq>(_POST, "/admin/specialEvent/get")(params);
};

/**
 * 列举商品列表
 * /admin/specialEvent/listProducts
 * */
const getSpecialEventProductList = (params: DakeListSpecialEventReq) => {
  return request<DakeListSpecialEventResp, DakeListSpecialEventReq>(_POST, "/admin/specialEvent/listProducts")(params);
};

const special = {
  getSpecialEventList,
  deleteSpecialEvent,
  updateSpecialEventShowInHome,
  createSpecialEvent,
  updateSpecialEvent,
  getSpecialEventDetail,
  getSpecialEventProductList,
  exportProducts,
};

export default special;
